(function () {
'use strict';

angular.module('hyresgastApp').controller('ShowRealEstateActiveNegotiationsCtrl', ShowRealEstateActiveNegotiationsCtrl);

function ShowRealEstateActiveNegotiationsCtrl(
  $scope, $document, $routeParams, $filter, $location,
  NegotiationTypes, CombinedNegotiationStates, NegotiationStates, Limits,
  HyUtils,
  RealEstate, Negotiation,
  ErrorHandler) {

  var vm = this;
  vm.Limits = Limits;
  vm.property = null;

  vm.activeStates = {
    NEW: NegotiationStates.NEW,
    IN_PREPARATION: NegotiationStates.IN_PREPARATION,
    SETTLEMENT: NegotiationStates.SETTLEMENT,
    IN_PROGRESS: NegotiationStates.IN_PROGRESS,
    BLOCKED: NegotiationStates.BLOCKED,
    PARTIALLY_BLOCKED: NegotiationStates.PARTIALLY_BLOCKED,
  };

  vm.statusChoices = Object.values(CombinedNegotiationStates)
    .filter(x => ![CombinedNegotiationStates.FINISHED,
      CombinedNegotiationStates.FINISHED_OUTSIDE_PORTAL].includes(x))
    .map(x => ({
      id: x,
      text: $filter('hyCombinedNegotiationStates')(x)
    }));
  vm.negotiationTypeChoices = Object.values(NegotiationTypes).map(x => ({
    id: x,
    text: $filter('hyNegotiationTypes')(x)
  }));

  let getTableau = () => angular.element($document[0].querySelector("#tableauActiveNegotiations"));
  const ffnArrayId = (value, filter) => !!(!filter.length || filter.find(x => x.id === value));
  vm.columns = [
    {
      title: 'Id',
      column: 'caseNumber'
    },
    {
      title: 'Namn',
      column: 'name'
    },
    {
      title: 'Organisation',
      column: 'counterpartOrganization.name'
    },
    {
      title: 'Förhandlingstyp',
      template: 'slot1',
      column: 'type',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.negotiationTypeChoices,
        multi: true,
      },
      ffn: ffnArrayId,
    },
    {
      title: 'Status',
      template: 'status',
      column: 'combinedState',
      lookup: {
        idProperty: 'id',
        textProperty: 'text',
        dictionary: vm.statusChoices,
        multi: true,
      },
      ffn: ffnArrayId,
    },
    {
      title: 'Ansvarig hos HGF',
      column: 'hgfNegotiator.fullName'
    },
    {
      title: 'Ansvarig hos organisation',
      column: 'extNegotiator.fullName'
    },
    {
      title: '',
      template: 'comment',
      filterType: 'none'
    }
  ];


  $scope.$parent.$watch('vm.property', property => {
    if (property) {
      vm.property = property;
      getTableau().scope().$broadcast('refresh');
    }
  });

  vm.getData = function() {
    // eslint-disable-next-line no-undef, no-unused-vars
    return new Promise((resolve, reject) => {
      if (!vm.property) {
        resolve('no property');
        return;
      }
      var activeStates = Object.values(vm.activeStates);
      RealEstate.queryNegotiationsForProperty({
        id: $routeParams.id,
        newPropertyIds: vm.property.newPropertyIds,
        'filters[state]': activeStates,
      }).$promise.then(function(response) { resolve(response) })
        .catch(ErrorHandler('Misslyckades att hämta förhandlingar.'));
    });
  }

  vm.editComment = negotiation => {
    HyUtils.showDefaultModal('EditCommentModalCtrl',
      'resources/agreement/rentlist/edit/edit-comment-modal.html',
      { comment: negotiation.comment, multipleComments: '' },
      result => {
        if (result.delete || result.comment) {
          negotiation.comment = result.delete ? '' : result.comment;
          Negotiation.saveComments([{
            negotiationId: negotiation.id,
            comment: negotiation.comment,
          }]);
          vm.isDirty = true;
        }
      }, null, null,
      { size: 'md' });
  };

  vm.gotoNegotiation = (negotiation) => {
    $location.search({});
    $location.path('/negotiations/' + negotiation.id);
  };

  vm.getContextInfo = row => ({
    title: `Förhandling ${row.caseNumber}`,
    link: '/negotiations/'+row.id,
  });
}


})();